<template>
  <el-dialog @close="$emit('update:visible',false)" v-bind="$attrs" :title="isEdit ? '编辑数据' : '添加一条数据'" class="dialog-1400" width="1200px">
    <el-form ref="form" :model="form" label-width="130px" v-loading="loading" :rules="PersonalFromRules">


      <el-tabs v-model="active">
        <el-tab-pane label="基本信息" name="1">
          <el-form-item label="姓名" prop="fullName">
            <el-input v-model="form.fullName" style="width:406px;" :maxlength="255" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="form.gender">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="出生年月" prop="birthday">
            <el-date-picker v-model="form.birthday" value-format="yyyy-MM-dd HH:mm:ss" type="month" placeholder="请选择出生年月">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="籍贯" prop="nativePlace">
            <el-input v-model="form.nativePlace" :maxlength="30" style="width:193px;" placeholder="请输入籍贯"></el-input>
          </el-form-item>
          <el-form-item label="民族" prop="nation">
            <el-input v-model="form.nation" style="width:193px;" :maxlength="20" placeholder="请输入民族"></el-input>
          </el-form-item>
          <el-form-item label="政治面貌" prop="politicalOutlook">
            <el-select style="width:193px;float: left;" v-model="form.politicalOutlook" placeholder="请选择政治面貌">
              <el-option v-for="item in politicalOutlookList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="其他" name="2">
          <el-form-item label="学历" prop="education" label-width="150px">
            <el-select style="width:193px;float: left;" v-model="form.education" placeholder="请选择学历">
              <el-option v-for="item in ['小学','初中','高中','职业高中','大专','本科','研究生','博士','博士后','其他']" :key="item" :label="item" :value="item"></el-option>
            </el-select>
            <el-form-item label="专业" prop="major" label-width="70px" style="float: left;margin-left: 20px;">
              <el-input style="width:193px;" v-model="form.major" :maxlength="255" placeholder="请输入专业"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="工作单位" prop="workUnit" label-width="150px">
            <el-input style="width:500px  ;float: left;" :maxlength="255" v-model="form.workUnit" placeholder="请输入工作单位"></el-input>
            <el-form-item label="职务/职称" prop="jobTitle" label-width="100px" style="float: left;margin-left: 20px;">
              <el-input style="width:193px;" :maxlength="255" v-model="form.jobTitle" placeholder="请输入职务/职称"></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="通讯地址" prop="address" label-width="150px">
            <el-input v-model="form.address" :maxlength="255" style="width:406px;" placeholder="请输入通讯地址"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="telephone" label-width="150px">
            <el-input v-model="form.telephone" :maxlength="12" style="width:406px;" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="身份证号码"  prop="idNumber" label-width="150px">
            <el-input v-model="form.idNumber" :maxlength="18" style="width:406px;" placeholder="请输入身份证号码"></el-input>
          </el-form-item>
          <el-form-item label="参加何学术团体任何职" prop="academicOrganization" label-width="150px">
            <el-input v-model="form.academicOrganization" :maxlength="255" placeholder="请输入参加何学术团体任何职"></el-input>
          </el-form-item>
          <el-form-item label="工作简历" prop="resume" label-width="150px">
            <el-input v-model="form.resume" placeholder="请输入工作简历" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="主要学术/获奖成果" prop="mainAcademic" label-width="150px">
            <el-input v-model="form.mainAcademic" :maxlength="255" placeholder="请输入主要学术/获奖成果"></el-input>
          </el-form-item>
          <!-- <el-form-item label="申请日期" prop="dateOfApplication" label-width="150px">
            <el-date-picker v-model="form.dateOfApplication"  type="date"  value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择申请日期">
            </el-date-picker>
          </el-form-item> -->
        </el-tab-pane>
        <el-tab-pane label="附件" name="3" >
          <el-form-item label="个人会员信息申请表" label-width="160px" prop="application">
            <UploadFile v-model="form.application" fileType="application"/>
          </el-form-item>
          <el-form-item label="职称证书复印件" label-width="160px" prop="profTitleCertificate">
            <UploadFile v-model="form.profTitleCertificate"  fileType="profTitleCertificate" />
          </el-form-item>
          <el-form-item label="执业资格证书复印件" label-width="160px" prop="profQualCertificate">
            <UploadFile v-model="form.profQualCertificate"  fileType="profQualCertificate"/>
          </el-form-item>
          <div class="explain">附注：此表格一式两份，请填写加签名（word格式）、职称证书复印件、执业资格证书复印件一并上传至本网站</div>
        </el-tab-pane>
      </el-tabs>



    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('update:visible',false)">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadFile from "@/components/UploadFile.vue";
import {  update as updateApi } from "@/api/individualMember.js";
import EditDialog from "../mixins/EditDialog.js";
import { PersonalFrom as PersonalFromRules } from "@/utils/rules.js";
import { politicalOutlookList } from "@/utils/index.js";
export default {
  components:{UploadFile},
  mixins: [EditDialog],
  data() {
    return {
      politicalOutlookList,
      PersonalFromRules,
      yearTurnover:[],
      updateApi,
      active: '1',
    };
  },
  methods:{
    onSubmit(){
      // 验证表单
      this.$refs["form"].validate((valid, key) => {
        if (valid) {
          // 调用mixins的添加方法
          this.submit()
        } else {
          let errKey = Object.values(key)[0][0];
          let field = errKey.field;
          this.$message.warning(errKey.message);
          // 跳转到对应的tab
          if (["username", "password",'accountType','memberType'].indexOf(field) != -1) {
            this.active = '0';
          } else if (
            [
              "birthday",
              "gender",
              "fullName",
              "nativePlace",
              "nation",
              "politicalOutlook",
            ].indexOf(field) != -1
          ) {
            this.active = '1';
          } else if (
            [
              "education",
              "major",
              "workUnit",
              "jobTitle",
              "address",
              "telephone",
              "idNumber",
              "academicOrganization",
              "resume",
              "mainAcademic",
              "dateOfApplication",
            ].indexOf(field) != -1
          ) {
            this.active = '2';
          } else{
            this.active = '3'
          }
          return false;
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
</style>